
export default {
    vagaBeneficio: {},
    vagasBeneficios: []
}